import React, { useState, useMemo } from 'react';
import { FaClock } from 'react-icons/fa';
import './TimeSlotPicker.scss';

const TimeSlotPicker = ({ 
  timeSlots = [], 
  selectedTime, 
  onTimeSelect,
  disabled = false 
}) => {
  const [selectedCategory, setSelectedCategory] = useState(null);

  // Categorize time slots
  const categorizedSlots = useMemo(() => {
    const categories = {
      morning: { label: 'صبح', slots: [], icon: '🌅' },
      afternoon: { label: 'بعدازظهر', slots: [], icon: '☀️' },
      evening: { label: 'عصر', slots: [], icon: '🌆' }
    };

    timeSlots.forEach(slot => {
      const hour = parseInt(slot.time.split(':')[0]);
      
      if (hour >= 6 && hour < 12) {
        categories.morning.slots.push(slot);
      } else if (hour >= 12 && hour < 17) {
        categories.afternoon.slots.push(slot);
      } else {
        categories.evening.slots.push(slot);
      }
    });

    // Filter out empty categories
    return Object.entries(categories)
      .filter(([_, category]) => category.slots.length > 0)
      .map(([key, category]) => ({ key, ...category }));
  }, [timeSlots]);

  // Auto-select first category if none selected
  React.useEffect(() => {
    if (!selectedCategory && categorizedSlots.length > 0) {
      setSelectedCategory(categorizedSlots[0].key);
    }
  }, [categorizedSlots, selectedCategory]);

  const handleTimeClick = (slot) => {
    if (!disabled && slot.available && onTimeSelect) {
      onTimeSelect(slot);
    }
  };

  const currentCategory = categorizedSlots.find(cat => cat.key === selectedCategory);

  return (
    <div className="time-slot-picker">
      {categorizedSlots.length > 1 && (
        <div className="time-categories">
          {categorizedSlots.map(category => (
            <button
              key={category.key}
              className={`category-tab ${selectedCategory === category.key ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category.key)}
            >
              <span className="category-icon">{category.icon}</span>
              <span>{category.label}</span>
            </button>
          ))}
        </div>
      )}

      <div className="time-slots-container">
        {currentCategory ? (
          <div className="time-slots-grid">
            {currentCategory.slots.map((slot, index) => {
              const isSelected = selectedTime && selectedTime.id === slot.id;
              const isDisabled = !slot.available || disabled;

              return (
                <button
                  key={slot.id || index}
                  className={`time-slot-btn ${isSelected ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
                  onClick={() => handleTimeClick(slot)}
                  disabled={isDisabled}
                >
                  <FaClock className="time-icon" />
                  <span className="time-text">{slot.time}</span>
                  {!slot.available && (
                    <span className="unavailable-badge">رزرو شده</span>
                  )}
                </button>
              );
            })}
          </div>
        ) : (
          <div className="no-slots-message">
            <FaClock className="no-slots-icon" />
            <p>زمانی در دسترس نیست</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TimeSlotPicker;

